import { GrowthBook, useFeatureIsOn as GBUseFeatureIsOn } from '@growthbook/growthbook-react';
import { EnvConfig } from '@model/config/env-config';
import { Logging } from '@util/logging';
import { AppVariant } from '@model/config/brands';

const API_HOST = 'https://cdn.growthbook.io';
const isWhiteLabel = AppVariant.isWhitelabel();
const CLIENT_KEY = EnvConfig.get().GROWTHBOOK_CLIENT_KEY || 'test-environment';

export const growthbook = isWhiteLabel
  ? null
  : new GrowthBook({
      apiHost: API_HOST,
      clientKey: CLIENT_KEY,
      enableDevMode: true,
      subscribeToChanges: true,
      trackingCallback: (experiment, result) => {
        Logging.log({ text: `Viewed Experiment: ${JSON.stringify(experiment)}, ${JSON.stringify(result)}` });
        const dataLayer = (window as any).dataLayer;
        if (dataLayer) {
          dataLayer.push({
            event: 'gb.experiment',
            gbExperimentId: experiment.name,
            gbVariationId: result.variationId
          });
        }
      }
    });
if (growthbook) {
  growthbook.init({
    streaming: true
  });
}
export const useFeatureIsOn = (featureId: string) => {
  return isWhiteLabel ? false : GBUseFeatureIsOn(featureId);
};
